import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

/**
 * Écrans du module Bénévolat (spec 005, T030) : espace gestion (candidatures, accès et
 * départs, administration des messages types) et espace bénévole simplifié (mes bénévoles
 * accompagnés). Chargés à la demande ; chaque écran revérifie ses droits côté serveur.
 */
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const load = () => import('./BenevolatPages.js');
const suite = () => import('./SuitePages.js');
const DashboardPage = page(suite, 'DashboardPage');
const CandidaturesPage = page(load, 'CandidaturesPage');
const CandidaturePage = page(load, 'CandidaturePage');
const AccessPage = page(load, 'AccessPage');
const SessionsPage = page(suite, 'SessionsPage');
const FollowupPage = page(suite, 'FollowupPage');
const MyTutorshipsPage = page(suite, 'MyTutorshipsPage');
const CutoverPage = page(suite, 'CutoverPage');
const BenevolatTab = lazy(() => suite().then((m) => ({ default: m.BenevolatTab })));
const AdminPage = page(load, 'AdminPage');

export const benevolatWeb: ModuleWeb = {
  module: 'benevolat',
  routes: [
    { path: '/benevolat', element: <DashboardPage /> },
    { path: '/benevolat/candidatures', element: <CandidaturesPage /> },
    { path: '/benevolat/candidatures/:id', element: <CandidaturePage /> },
    { path: '/benevolat/sessions', element: <SessionsPage /> },
    { path: '/benevolat/acces', element: <AccessPage /> },
    { path: '/benevolat/suivi', element: <FollowupPage /> },
    { path: '/benevolat/mes-tutorats', element: <MyTutorshipsPage /> },
    { path: '/benevolat/admin', element: <AdminPage /> },
    { path: '/benevolat/admin/bascule', element: <CutoverPage /> },
  ],
  personTabs: [
    {
      key: 'benevolat',
      label: 'Bénévolat',
      gestionOnly: true,
      render: (personId: string) => <BenevolatTab personId={personId} />,
    },
  ],
};
